export const mainNum = 5

export const FIELD_REMOVE_SPACES = ['sku_barcode']

export const EXTRA_FIELD_IDS = [
    'sku_barcode',
    'sku_MarketTime',
    'sku_official_price',
    'sku_ProductCode',
    'sku_HdHeight',
    'sku_HdLength',
    'sku_HdWidth',
    'hscode',
    'mic_price_wall_max_length',
    'mic_price_hd_length',
    'mic_price_light',
    'mic_price_hd_height',
    'skuCombineContent'
]

// sku 额外字段 有就显示
export const SKU_PICTURE = 'skuPicture' // sku 图片
export const SKU_TITLE = 'skuTitle' // sku 标题
